import _ from 'lodash'
import query from '../../List/Items/lib/query'

export default (cache, {
  data: {
    createGateway,
  },
}) => {
  const { gateways } = cache.readQuery({ query })

  cache.writeQuery({
    query,
    data: { gateways: _.concat(gateways, createGateway) },
  })
}
